module.exports = __webpack_public_path__ + "static/media/olx.7d8aab2a.PNG";